export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">番茄视频</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                番茄视频聚合妖精视频、桃花视频、苹果视频、榴莲视频等特色内容，动漫、短视频、搞笑视频、趣味节目一应俱全，高清画质免费在线观看，发现更多精彩。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                快速导航
              </h4>
              <div className="flex flex-col gap-2">
                <a href="#hero" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">首页</a>
                <a href="#ranking" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">热门榜单</a>
                <a href="#topics" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">话题广场</a>
                <a href="#carousel" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">精选专题</a>
                <a href="#features" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">平台特色</a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                内容分类
              </h4>
              <div className="flex flex-col gap-2">
                <span className="text-sm text-background-400 whitespace-nowrap">动漫新番</span>
                <span className="text-sm text-background-400 whitespace-nowrap">搞笑合集</span>
                <span className="text-sm text-background-400 whitespace-nowrap">短视频精选</span>
                <span className="text-sm text-background-400 whitespace-nowrap">特色节目</span>
                <span className="text-sm text-background-400 whitespace-nowrap">综艺热播</span>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                合作伙伴
              </h4>
              <p className="text-sm text-background-500 italic">
                更多合作伙伴即将入驻，敬请期待。
              </p>
            </div>
          </div>

          <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 番茄视频. 本站内容仅供学习交流，如有侵权请联系删除。
            </p>
            <div className="flex items-center gap-5">
              <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
              <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">使用条款</span>
              <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}